import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12h2l4 8l4 -16h8","key":"svg-0"}]]

const IconSquareRoot = createReactComponent('outline', 'square-root', 'SquareRoot', __iconNode);

export default IconSquareRoot;